export default __webpack_public_path__ + "static/media/4.25e40c9a.png";